export default {
  name: 'definedLibrary',
  getSearchList: {
    url: '/rc-api/columns/getSearchList'
  }
}
